// Redy admin design system — primitives.
// Spec: docs/design-system/2026-05-25-DESIGN_SYSTEM_SPEC.md

export { Button } from "./Button"
export type { ButtonProps } from "./Button"

export { IconButton } from "./IconButton"
export type { IconButtonTone, IconButtonSize, IconButtonVariant } from "./IconButton"

export { Toggle } from "./Toggle"
export type { ToggleProps } from "./Toggle"
export { Slider } from "./Slider"
export type { SliderProps } from "./Slider"

export { Popover } from "./Popover"
export type { PopoverProps } from "./Popover"

export { Card, KpiCard } from "./Card"
export type { CardProps, KpiCardProps, KpiCardValueAccent } from "./Card"

export {
  Input,
  Select,
  Textarea,
  FormField,
  inputClass,
} from "./Input"
export type {
  InputProps,
  SelectProps,
  TextareaProps,
  FormFieldProps,
} from "./Input"

export { EmailInput } from "./EmailInput"
export type { EmailInputProps } from "./EmailInput"

export { PhoneInput } from "./PhoneInput"
export type { PhoneInputProps } from "./PhoneInput"

export { Badge, StatusBadge, statusTone, statusLabel } from "./Badge"
export type { BadgeProps, BadgeTone, StatusBadgeProps } from "./Badge"

export { PageHeader, PageShell, PageBody } from "./PageHeader"
export type { PageHeaderProps, Crumb } from "./PageHeader"

export { EmptyState } from "./EmptyState"
export type { EmptyStateProps } from "./EmptyState"

export { LoadingState } from "./LoadingState"
export type { LoadingStateProps } from "./LoadingState"

export { SectionCard, SectionHeader } from "./SectionCard"
export type { SectionCardProps, SectionHeaderProps } from "./SectionCard"

export { Tabs } from "./Tabs"
export type { TabsProps } from "./Tabs"

export { ToggleGroup } from "./ToggleGroup"
export type {
  ToggleGroupProps,
  ToggleGroupOption,
  ToggleGroupVariant,
  ToggleGroupSize,
} from "./ToggleGroup"

export { DataTable } from "./DataTable"
export type { DataTableColumn, DataTableProps } from "./DataTable"

export { LocaleSwitcher } from "./LocaleSwitcher"
export { Menu } from "./Menu"

export { ExportMenu } from "./ExportMenu"
export type { ExportMenuProps, ExportMenuOption } from "./ExportMenu"

export { SaveStatus } from "./autosave/SaveStatus"
export type { SaveStatusProps } from "./autosave/SaveStatus"
export { useAutosaveField } from "./autosave/useAutosaveField"
export type { UseAutosaveFieldOptions, AutosaveFieldApi } from "./autosave/useAutosaveField"
export { AutosaveField } from "./autosave/AutosaveField"
export type { AutosaveFieldProps } from "./autosave/AutosaveField"
export { clampNumber } from "./autosave/core"
